
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 19.5a2 2 0 01-2 2h-19a2 2 0 01-2-2v-1h23v1zm-21 2v2m19-2v2m-9.5-5H7v-17a1 1 0 011-1h3a1 1 0 011 1v17zm5.144 0L15.156 2.094a1 1 0 01.872-1.113L19.006.62a1 1 0 011.113.873L22.18 18.5m-7.18 0h-3v-15h2a1 1 0 011 1v14zm-8 0H2v-17a1 1 0 011-1h3a1 1 0 011 1v17zm2-3h1m-6 0h1m-.5-12v9m5-9v9","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M19 14.5a1 1 0 100-2 1 1 0 000 2z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    